<template>
	<v-app id="dashboard">
		<v-content>
			<v-container fluid full-height style="padding: 0px;">
				<router-view v-transition></router-view>
			</v-container>
		</v-content>
	</v-app>
</template>


<script>
export default {
	name: 'dashboard'
}
</script>

<style type="text/css">
html:has(#dashboard) {
  overflow: hidden !important;
}
#dashboard {
	background-color: #114470 !important;
}

</style>




// WEBPACK FOOTER //
// src/layouts/dashboard.vue